import React from 'react';
import mixpanel from 'mixpanel-browser';

import { Link } from '@mui/material';

import { QUORUM_FCU } from '../Logos';

import { CONTACT_FOR_RATES } from '../../../constants/ComparisonSummary';

export const QuorumContact = ({ url, financingType }) => {
  const handleClick = () => {
    mixpanel.track(`Rates Info ${financingType}`, {
      url,
      path: window?.location?.pathname,
      lenderName: QUORUM_FCU,
    });
  };

  return (
    <div>
      <Link
        sx={{ fontFamily: 'sans-serif', fontSize: { xs: '12.75px', sm: '14px' } }}
        onClick={handleClick}
        underline="hover"
        variant="outline"
        href={url}
        target="_blank"
      >
        {CONTACT_FOR_RATES}
      </Link>
    </div>
  );
};
